import { FeatureFlagDeclarations } from '../feature-flags/feature-flag-declarations';
import { useEnablePickListHtmlEditor } from '../feature-flags/hooks/use-enable-pick-list-html-editor';
import { useEnablePickListTemplateSelection } from '../feature-flags/hooks/use-enable-pick-list-template-selection';
import { useFeatureFlag } from '../feature-flags/hooks/use-feature-flag';
import { usePickListTemplatesFeatureGate } from './use-pick-list-templates-feature-gate';

export const useIsPickListTemplateSelectionAvailable = (): boolean => {
  const isHtmlEditorEnabled = useEnablePickListHtmlEditor();
  const isTemplateSelectionEnabled = useEnablePickListTemplateSelection();
  const shouldSendV3QueueServiceDownloadUrl = useFeatureFlag(FeatureFlagDeclarations.shouldSendV3QueueServiceDownloadUrl);
  const { isFeatureEnabled } = usePickListTemplatesFeatureGate();

  return isHtmlEditorEnabled && isTemplateSelectionEnabled && shouldSendV3QueueServiceDownloadUrl && isFeatureEnabled;
};
